import { createGlobalStyle } from "styles/styled_components";
import GraphikRegular from "fonts/Graphik-Regular.otf";
import GraphikRegularItalic from "fonts/Graphik-RegularItalic.otf";
import GraphikMedium from "fonts/Graphik-Medium.otf";

const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  * {
    box-sizing: border-box;
  }

  body {
    background-color: ${(props) => props.theme.colors.brandWhite};
    font-family: ${(props) => props.theme.text.primaryFamily};
    font-size: ${(props) => props.theme.text.size.base};
    line-height: ${(props) => props.theme.text.lineHeight.base};
    margin: 0;
    overflow-y: scroll;
  }

  ol, ul {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    text-decoration: none;
  }

  @font-face {
    font-family: 'Graphik-Regular';
    src: url(${GraphikRegular});
  }
  @font-face {
    font-family: 'Graphik-RegularItalic';
    src: url(${GraphikRegularItalic});
  }
  @font-face {
    font-family: 'Graphik-Medium';
    src: url(${GraphikMedium});
  }
`;

export default GlobalStyle;
